import React, { useEffect, useState } from "react"
import { usePermissions } from "hooks"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import { Button, Card, CardBody, Col, Container, Row, Table } from "reactstrap"

import BackButton from "components/Shared/BackButton"
import Spinners from "components/Shared/Spinners"
import { getPromoteSuggestion } from "store/actions/practicalTrainingAction"

import { getJobTitlesList } from "store/actions/commonAction"
import NoDataAvailable from "components/Shared/NoDataAvailable"
import { Check } from "lucide-react"
import ChangeJobTitleModal from "./components/ChangeJobTitleModal"

const columns = [
  { key: "serial", label: "S. No." },
  { key: "name", label: "Participant Name" },
  { key: "national_id", label: "National Id" },
  { key: "current_title", label: "Current Job Title" },
  { key: "suggested_title", label: "Suggested Job Title" },
  { key: "reason", label: "Reason" },
  { key: "action", label: "Action" },
]

const TrainingPromotionSuggestions = () => {
  const { loading, promotionList } = useSelector(
    state => state.PracticalTraining
  )

  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { permissions, showAll } = usePermissions("practical_training")
  const { search } = useLocation()
  const { jobTitlesList } = useSelector(state => state.Common)

  const uuid = new URLSearchParams(search).get("uuid")

  const [modal, setModal] = useState(false)
  const [selectedUuid, setSelectedUuid] = useState(null)
  const [trigger, setTrigger] = useState(false)
  const [suggestedJobTitle, setSuggestedJobTitle] = useState(null)

  useEffect(() => {
    dispatch(getJobTitlesList())
  }, [])

  useEffect(() => {
    getAllData()
  }, [trigger, uuid])

  const getAllData = () => {
    dispatch(getPromoteSuggestion({ training_uuid: uuid }))
  }

  return (
    <React.Fragment>
      <div className="page-content">
        {loading ? (
          <Spinners />
        ) : (
          <Container fluid>
            <Row>
              <Col xl="12">
                <div className="d-flex justify-content-between mb-4 align-items-center">
                  <h4 className="card-title ">
                    <BackButton />
                    {t("Promotion Suggestions")}
                  </h4>
                </div>

                <Card className="user_personal_info theme_card overflow-x-auto">
                  <CardBody>
                    {!loading && promotionList.length === 0 ? (
                      <NoDataAvailable />
                    ) : (
                      <div className="table-responsive">
                        <Table className="table mb-0">
                          <thead className="table-light full_th">
                            <tr>
                              {columns.map(col => (
                                <th key={col.key}>{t(col.label)}</th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {promotionList.map((item, index) => (
                              <tr key={index}>
                                <th scope="row">{index + 1}</th>
                                <td>{item?.user_name || "-"}</td>
                                <td>{item?.user_national_id || "-"}</td>
                                <td>{item?.current_job_title || "-"}</td>
                                <td>{item?.suggested_job_title || "-"}</td>
                                <td>{item?.reason || "-"}</td>
                                <td>
                                  {item?.current_job_title !==
                                    item?.suggested_job_title && (
                                    <Button
                                      color="primary"
                                      size="sm"
                                      title={t("Promote")}
                                      onClick={() => {
                                        setSelectedUuid(
                                          item.job_applicant_assessment_uuid
                                        )
                                        setSuggestedJobTitle(
                                          item.suggested_job_title
                                        )
                                        setModal(true)
                                      }}
                                    >
                                      <Check size={12} />
                                    </Button>
                                  )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        )}
      </div>
      {modal && (
        <ChangeJobTitleModal
          isOpen={modal}
          toggle={() => {
            setModal(false)
            setSelectedUuid(null)
          }}
          jobTitlesList={jobTitlesList}
          updateJobTitle
          training_uuid={uuid}
          user_uuid={selectedUuid}
          trigger={() => setTrigger(!trigger)}
          suggestedJobTitle={suggestedJobTitle}
        />
      )}
    </React.Fragment>
  )
}

export default TrainingPromotionSuggestions
